import env from "react-dotenv";

let orderedSentiment = {
    'name': 'sentiment_d',
    'label': 'Sentiment',
    'type': 'ATTRIBUTE',
    'dependencies': ['sentiment'],
    'reverse': (sentiment) => { 
         return sentiment
      },
    'function': (sentiment) => {
          let dict = {
              'Positive' : { value: 'Positive', order: 1 },
              'Neutral' : { value: 'Neutral', order: 2 },
              'Mixed' : { value: 'Mixed', order: 3 },
              'Negative' : { value: 'Negative', order: 4 },
          }
          return dict[sentiment];
      }
    
  }

  let partitions = (start, end) => {
    var result = [];
  
    for (var i = start; i <= end; i++) {
       result.push(i);
    }
    return result;
  }
  
  let routingObj = {
      path : 'created_at',
      function: (obj) => {
          let cf = window.cf;
          let result = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
          if (obj.created_at) {
            let moment = cf.getDependency('moment');
            let fromDate = moment(obj.created_at[0], 'YYYY-MM-DD HH:mm:ss.SSS').toDate();
            let toDate = moment(obj.created_at[1], 'YYYY-MM-DD HH:mm:ss.SSS').toDate()
            result = partitions(fromDate.getMonth() + 1,toDate.getMonth() + 1 );
          }
          return result;
      } 
  };  

export const setProvider = function () {
    window.cf.setProviders([{
        name: 'es01',
        provider: 'elasticsearch',
        url: `${env.ES_HOST}:${env.ES_PORT}`,
        metadata: {
            "vc_airline_tweets": {
                "tz": 'local', 
                "count": {
                    label: 'Tweets'
                },
                routing: routingObj,
                fields: {
                    created_at: {
                        label: 'Created at'
                    },
                    "text.keyword": {
                        label: 'Text'
                    },
                    "airline": {
                        "label": "Airline"
                    },
                    "sentiment": {
                        "label": "Sentiment (unordered)"
                    },
                    kwd_category: {
                        label: 'Category'
                    },
                    "entities.Text": {
                        label: 'Entities'
                    },
                    "key_phrases.Text": {
                        label: 'Key phrases'
                    },
                    user_name: {
                        label: 'Name'
                    },
                    user_screen_name: {
                        label: 'User name'
                    },
                    user_profile_image_url: {
                        label: 'Profile image'
                    },
                    "sentiment_d": orderedSentiment,
                }
            }
        }
    }])
}